module.exports = __webpack_public_path__ + "img/Cote d'Ivoire.b3bdc289.svg";